import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    productagepolicyisLoading : false,
    productagepolicy: [],
    totalCurrency: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    productagepolicyiscLoading:false,
    productagepolicyCstatus:"",
    productagepolicyCMessage:"",
    productagepolicydetails:{},
    productagepolicyismloading:false,
    productagepolicymstatus:"",
    productagepolicymmessage:"",
    agepolicies: {},
    productagepolicydstatus:"",
    productagepolicydmessage:"",
    error:"",
    
};


const productagepolicySlice = createSlice({
    name: "agepolicyList",
    initialState,
    reducers:{
        getProductAgePolicyPending: (state) => {
            state.productagepolicyisLoading = true;
        },
        getProductAgePolicySuccess: (state, { payload }) => {
            state.productagepolicyisLoading = false;
            state.productagepolicy = payload;
            state.productagepolicydetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getProductAgePolicyFail: (state, { payload }) => {
            state.productagepolicyisLoading = false;
            state.error = payload;
        },
        createProductAgePolicyPending:(state,action) => {
            state.productagepolicyiscLoading=true;
        },
        createProductAgePolicySuccess:(state,{payload}) => {
            state.productagepolicyiscLoading=false;
            state.productagepolicyCstatus="success";
            state.productagepolicyCMessage=payload;
        },
        createProductAgePolicyFail:(state,{payload}) => {
            state.productagepolicyiscLoading=false;
            state.productagepolicyCstatus="fail";
            //console.log('slice '+payload);
            state.productagepolicyCMessage=payload;
        },
        getSProductAgePolicyPending: (state) => {
            state.productagepolicyisLoading = true;
        },
        getSProductAgePolicySuccess: (state, { payload }) => {
            state.productagepolicyisLoading = false;
            state.agepolicies=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSProductAgePolicyFail: (state, { payload }) => {
            state.productagepolicyisLoading = false;
            state.error = payload;
        },
        modifyProductAgePolicyPending:(state,action) => {
            state.productagepolicyismloading=true;
            state.productagepolicymstatus="";
        },
        modifyProductAgePolicySuccess:(state,{payload}) => {
            state.productagepolicyismloading=false;
            state.productagepolicymstatus="success";
           
            state.productagepolicymmessage="ProductAgePolicy Successfully Updated";
        },
        modifyProductAgePolicyFail:(state,{payload}) => {
            state.productagepolicyismloading=false;
            state.productagepolicymstatus="fail";
           // console.log('slice '+payload);
            state.productagepolicymmessage=payload;
        },
        deleteProductAgePolicyPending:(state,action) => {
            state.productagepolicyisloading=true;
            state.productagepolicydstatus="";
        },
        deleteProductAgePolicySuccess:(state,{payload}) => {
            state.productagepolicyisLoading=false;
            state.productagepolicydstatus="success";
            state.productagepolicydmessage="ProductAgePolicy Successfully Deleted";
        },
        deleteProductAgePolicyFail:(state,{payload}) => {
            state.productagepolicyisLoading=false;
            state.productagepolicydstatus="fail";
           // console.log('slice '+payload);
            state.productagepolicydmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = productagepolicySlice;

export const { getProductAgePolicyPending, getProductAgePolicySuccess, getProductAgePolicyFail,getSProductAgePolicyPending, getSProductAgePolicySuccess, getSProductAgePolicyFail, 
    createProductAgePolicyPending, createProductAgePolicySuccess, createProductAgePolicyFail,
    modifyProductAgePolicyPending,modifyProductAgePolicySuccess,modifyProductAgePolicyFail,
    deleteProductAgePolicyPending,deleteProductAgePolicySuccess,deleteProductAgePolicyFail  } = actions;

export default reducer;
